













































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class SearchSideBar extends Vue {
  @Prop() private aggregatedCategories!: any;
  @Prop() private category!: string;
  @Prop() private subcategory!: string;
  @Prop() private leaf!: string;
  @Prop() private treeTypes!: any;
  @Prop() private displayType!: string;
  @Prop() private groupCount!: number;
  @Prop() private taxcodesCount!: number;

  private expanded = true;

  get userDisplayType() {
    return this.displayType || "taxcodes";
  }

  itemTypeCount(type: any) {
    if (this.displayType === "group") return type.treeCount;

    return type.count;
  }

  categoryCount(category: any) {
    if (this.displayType === "group") return category.trees.size;

    return category.count;
  }

  get treeTypesRender() {
    return Object.keys(this.treeTypes)
      .filter((t) => this.itemTypeCount(this.treeTypes[t]) > 0)
      .map((t, i) => {
        return {
          name: t,
          active: this.isTreeTypeSelected(t),
          count: this.treeTypes[t].count,
          treeCount: this.treeTypes[t].treeCount,
        };
      });
  }

  get categoryData() {
    if (!this.category) {
      return {
        "": {
          subcategories: Object.values(this.aggregatedCategories),
        },
      };
    } else if (!this.subcategory) {
      return {
        [this.category]: {
          subcategories: Object.values(
            this.aggregatedCategories[this.category].subcategories
          ),
        },
      };
    } else if (!this.leaf) {
      return {
        [this.subcategory]: {
          subcategories: Object.values(
            this.aggregatedCategories[this.category].subcategories[
              this.subcategory
            ].leaves
          ),
        },
      };
    } else {
      return {};
    }
  }

  header(category, categoryDetail) {
    if (
      category &&
      categoryDetail.subcategories.filter((s) => s.name).length > 0
    )
      return category;
    else if (category) return "";
    else return "Categories";
  }

  display(t) {
    const query = Object.assign({}, this.$route.query);
    query.displayType = t;

    this.$router.push({ query });
  }

  filter(c) {
    const query = Object.assign({}, this.$route.query);

    if (!this.category) query.category = c;
    else if (!this.subcategory) query.subcategory = c;
    else if (!this.leaf) query.leaf = c;

    this.$router.push({ query });
  }

  filterTreeType(treeType, e) {
    const query = Object.assign({}, this.$route.query);

    if (!query.treeTypes) {
      query.treeTypes = [treeType];
    } else if (query.treeTypes.includes(treeType)) {
      query.treeTypes = (query.treeTypes as []).filter(
        (t: string) => t !== treeType
      );
    } else {
      query.treeTypes = (query.treeTypes as []).concat(treeType);
    }

    this.$router.push({ query });
  }

  isTreeTypeSelected(treeType) {
    const query = this.$route.query;
    const treeTypes = query.treeTypes;

    if (!treeTypes) {
      return false;
    }

    return treeTypes.includes(treeType);
  }

  defilter() {
    const query = Object.assign({}, this.$route.query);
    if (this.leaf) delete query.leaf;
    else if (this.subcategory) delete query.subcategory;
    else if (this.category) delete query.category;

    this.$router.push({ query });
  }

  get backText() {
    if (this.leaf) return this.subcategory;
    if (this.subcategory) return this.category;
    if (this.category && this.$route.query.q) return "all categories";
    return "";
  }
}
